import { render, staticRenderFns } from "./InEventSidebarNav.vue?vue&type=template&id=5f184749"
import script from "./InEventSidebarNav.vue?vue&type=script&lang=js"
export * from "./InEventSidebarNav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports